import React from 'react';
import { useParams, useLocation, Navigate } from 'react-router-dom';
import ListViewLayout from '../../layout/ListViewLayout';
import DetailLayout from '../../layout/DetailLayout';
import EditLayout from '../../layout/EditLayout';

/** Redirect /listview/user to /setup/users */
export const RedirectUserList = () => <Navigate to="/setup/users" replace />;

/** Redirect /view/user/:id to /setup/users/:id */
export const RedirectUserView = () => {
  const { id } = useParams();
  return <Navigate to={`/setup/users/${id}`} replace />;
};

/** Redirect /edit/user or /edit/user/:id to setup users create or edit */
export const RedirectUserEdit = () => {
  const { id } = useParams();
  if (id) return <Navigate to={`/setup/users/${id}/edit`} replace />;
  return <Navigate to="/setup/users/create" replace />;
};

const OBJECT_NAME = 'user';

/**
 * User list under Setup — same as /listview/user but at /setup/users.
 */
export const SetupUserList = () => {
  const location = useLocation();
  return <ListViewLayout objectName={OBJECT_NAME} location={location} />;
};

/**
 * User detail under Setup — same as /view/user/:id but at /setup/users/:id.
 */
export const SetupUserView = ({ socket, selectedWhatsAppSetting }) => {
  const { id } = useParams();
  return (
    <DetailLayout
      objectName={OBJECT_NAME}
      id={id}
      socket={socket}
      selectedWhatsAppSetting={selectedWhatsAppSetting}
    />
  );
};

/**
 * User edit under Setup — same as /edit/user/:id but at /setup/users/:id/edit.
 */
export const SetupUserEdit = () => {
  const { id } = useParams();
  const location = useLocation();
  let sourcePage = 'listview';
  if (location.state?.sourcePage) sourcePage = location.state.sourcePage;
  else if (document.referrer?.includes('/view/')) sourcePage = 'detail';
  const searchParams = new URLSearchParams(location.search);
  const targetfield = searchParams.get('targetfield');
  const targetid = searchParams.get('targetid');
  const queryParams = targetfield && targetid ? { targetField: targetfield, targetId: targetid } : null;
  return (
    <EditLayout
      objectName={OBJECT_NAME}
      id={id}
      sourcePage={sourcePage}
      queryParams={queryParams}
    />
  );
};
